import React from 'react';
import LoadingIcon from '../LoadingIcon';
import styles from './Button.module.scss'; //need to import even if not using classes, to apply default styles

const Button = ({ classNames = [], className, children, type, onClick, loading, disabled }) => {
  let icon = null;
  className && classNames.push(className);
  if (loading) {
    classNames.indexOf(styles.loading) === -1 && classNames.push(styles.loading);
    disabled = true;
    icon = <LoadingIcon />;
  }
  return (
    <button className={classNames.join(' ') + ' ' + styles.button} type={type} onClick={onClick} disabled={disabled}>
      {icon}
      {children}
    </button>
  );
};

export default Button;
